/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./group-item.vue?vue&type=template&id=adc3acb0&scoped=true&"
import script from "./group-item.vue?vue&type=script&lang=js&"
export * from "./group-item.vue?vue&type=script&lang=js&"
import style0 from "./group-item.vue?vue&type=style&index=0&id=adc3acb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc3acb0",
  null
  
)

export default component.exports